module.exports = girder_plugin_histomicsui;


//////////////////
// WEBPACK FOOTER
// external "girder_plugin_histomicsui"
// module id = 4
// module chunks = 0